"use client";
import { jsxs as d, jsx as t } from "react/jsx-runtime";
import p from "../../common/images/ImgEmptyState.js";
import s from "../button/Button.js";
import y from "../heading/Heading.js";
import h from "../link/Link.js";
import S from "../text/Text.js";
import r from "@emotion/styled";
import { FONT_WEIGHTS as x } from "../../tokens/font-weights/FontWeights.js";
import { SPACINGS as l } from "../../tokens/spacings/Spacings.js";
import { forwardRef as f } from "react";
const c = f(
  ({ feButton: o, feHeading: e, feLink: i, feText: m, ...a }, n) => /* @__PURE__ */ d(g, { ...a, "data-comp": "empty-state", ref: n, children: [
    /* @__PURE__ */ t(E, { children: /* @__PURE__ */ t(p, {}) }),
    (e ?? m) && /* @__PURE__ */ d($, { children: [
      e && /* @__PURE__ */ t(v, { as: e.as ?? "h2", feStyledAs: "h2", children: e.children }),
      m && /* @__PURE__ */ t(w, { feColor: "gray700", children: m })
    ] }),
    (i ?? o) && /* @__PURE__ */ d(I, { children: [
      i && /* @__PURE__ */ t(h, { ...i, as: "a", children: i.children }),
      o && /* @__PURE__ */ t(s, { ...o, feType: "primary", children: o.children })
    ] })
  ] })
);
c.displayName = "EmptyState";
const P = c, g = r.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	gap: ${l.lg};
	text-align: center;
`, E = r.div`
	width: min(100%, 320px);
`, $ = r.div`
	display: flex;
	flex-direction: column;
	gap: ${l.xs};
`, v = r(y)`
	font-weight: ${x.normal};
	margin-block-start: ${l.xs};
`, w = r(S)`
	max-width: 50ch;
`, I = r.div`
	display: flex;
	gap: ${l.xl};
	justify-content: center;
`;
export {
  P as default
};
